import Head from "next/head";
import NavBar from "@/components/templates/NavBar";
import Slider from "@/components/templates/Slider";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Hero from "@/components/organisms/Hero";
import Footer from "@/components/templates/Footer";
import Newsletter from "@/components/templates/Newsletter";
import Booking from "@/components/templates/Booking";
import IconItems from "@/components/molecules/IconItems";
import ContactForm from "@/components/templates/ContactForm";
import Title from "@/components/atoms/Title";

export default function Page(props) {
  const { noIndex } = props;
  const { t } = useTranslation("common", "contact");
  const sliders = t("contact:sliders", { returnObjects: true });
  let icons = t("contact:items", { returnObjects: true });
  icons = icons?.map((icon) => {
    const paragraphs =
      icon?.paragraphs?.map((p) => {
        return {
          ...p,
          classes: "hero-text",
        };
      }) || [];
    return {
      ...icon,
      paragraphs: [
        {
          text: icon?.title,
          classes: "font-subtitle text-base md:text-xl text-main-blue",
        },
        ...paragraphs,
      ],
    };
  });
  return (
    <>
      <Head>
        <title>{t("contact:metas.title")}</title>
        <meta name="description" content={t("contact:metas.description")} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {noIndex && <meta name="robots" content="noindex" />}
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={t('common:canonical_pages.contact')} />
      </Head>
      <main>
        <NavBar />
        <Booking />
        <Slider sliders={sliders} />

        <Hero
          text={{
            text: t("contact:text"),
            className: "section-subtitle text-center",
          }}
          title={{
            text: t("contact:title"),
            tag: "h1",
            className: "hero-title mb-6 md:mb-12 text-3xl md:text-5xl",
          }}
          styles={{
            heroContainer: "base-container pt-6 md:pt-12 md:pb-0",
            textContainer: "col-span-12 md:col-start-2 md:col-span-10 order-0",
            titleContainer: "col-span-12 md:col-start-2 md:col-span-10 order-1",
          }}
        />
        <IconItems items={icons} />
        <ContactForm />
        <Newsletter />
        <Footer />
      </main>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  const noIndex = process.env.ENV_NO_INDEX || false;
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "contact",
        "routes",
      ])),
      noIndex,
    },
  };
}
